import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-format-underline",
  templateUrl: "./med-icon-format-underline.component.html",
})
export class MedIconFormatUnderlineComponent extends SvgMixinComponent {}
